import { render, staticRenderFns } from "./CourseShare.vue?vue&type=template&id=463614a6&scoped=true&"
import script from "./CourseShare.vue?vue&type=script&lang=js&"
export * from "./CourseShare.vue?vue&type=script&lang=js&"
import style0 from "./CourseShare.vue?vue&type=style&index=0&id=463614a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463614a6",
  null
  
)

export default component.exports